import React from 'react';
import {Provider} from "components/foreigner-register/ForeignerRegisterContext";
import {ForeignerRegisterList} from "components/foreigner-register/ForeignerRegisterList";

export const ForeignerRegisters = () => {

    return (
        <Provider>
            <ForeignerRegisterList/>
        </Provider>
    );
}
